import { State } from './';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} newState - new state
 * @param {State} oldState - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { loading, overlayOpen, overlayLoaded, activeView, isFriendsAndFamily, primaryCard } = state;
    const friendsAndFamilyChanged = isFriendsAndFamily !== oldState.isFriendsAndFamily;

    return {
        view: activeView !== oldState.activeView,
        loading: loading !== oldState.loading,
        overlay: overlayOpen !== oldState.overlayOpen,
        leadManagement: overlayLoaded && overlayLoaded !== oldState.overlayLoaded,
        friendsAndFamily: friendsAndFamilyChanged,
        imageHeader: primaryCard !== oldState.primaryCard || friendsAndFamilyChanged,
    };
};
